// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout .au-scope {
  /* Space scale — 4px base, tighter than the dashboard side */
  --admin-s0: 0;
  --admin-s1: 2px;
  --admin-s2: 4px;
  --admin-s3: 8px;
  --admin-s4: 12px;
  --admin-s5: 16px;
  --admin-s6: 20px;
  --admin-s7: 28px;
  --admin-s8: 40px;

  /* Radii — sharp. 999px only on status dots, never on buttons. */
  --admin-radius-sm: 3px;
  --admin-radius-md: 5px;
  --admin-radius-lg: 8px;
  --admin-radius-dot: 999px;

  /* Type scale */
  --admin-text-micro: 10px;
  --admin-text-xs: 11px;
  --admin-text-sm: 12px;
  --admin-text-base: 13px;
  --admin-text-md: 14px;
  --admin-text-lg: 18px;
  --admin-font-weight-normal: 500;
  --admin-font-weight-semibold: 600;
  --admin-font-weight-bold: 700;
  --admin-tracking-caps: 0.08em;
  --admin-tracking-tight: -0.005em;

  /* Surface layering */
  --admin-bg-base: #0a0a0a;
  --admin-bg-surface-1: rgba(255, 255, 255, 0.025);
  --admin-bg-surface-2: rgba(255, 255, 255, 0.05);
  --admin-bg-surface-3: rgba(255, 255, 255, 0.08);
  --admin-bg-hover: rgba(255, 255, 255, 0.04);
  --admin-bg-active: rgba(255, 255, 255, 0.07);
  --admin-bg-sunken: rgba(0, 0, 0, 0.22);

  /* Borders */
  --admin-border-subtle: 1px solid rgba(255, 255, 255, 0.06);
  --admin-border-default: 1px solid rgba(255, 255, 255, 0.1);
  --admin-border-strong: 1px solid rgba(255, 255, 255, 0.18);

  /* Text */
  --admin-text-primary: rgba(255, 255, 255, 0.96);
  --admin-text-secondary: rgba(255, 255, 255, 0.62);
  --admin-text-muted: rgba(255, 255, 255, 0.4);
  --admin-text-placeholder: rgba(255, 255, 255, 0.28);

  /* Accent */
  --admin-accent: #ef4444;
  --admin-accent-ink: #ffffff;
  --admin-accent-wash: rgba(239, 68, 68, 0.14);

  /* Semantic status */
  --admin-status-critical: #f87171;
  --admin-status-signal: #fbbf24;
  --admin-status-ambient: #9ca3af;
  --admin-status-ok: #4ade80;

  /* Motion */
  --admin-transition-fast: 120ms ease;
  --admin-transition-base: 180ms ease;

  /* Shell metrics */
  --admin-shell-pad-x: 24px;
  --admin-shell-top: 48px;
  --admin-shell-rail: 44px;
  --admin-sidebar-w: 240px;
}

.admin-layout .sandbox-page {
  --sbx-rail-offset: calc(48px + 44px);
  --sbx-grid-gap: 12px;
  --sbx-side-panel-w: clamp(320px, 28vw, 420px);
}

:root {
  --admin-portal-z: 12000;
}

.admin-layout .au-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/admin.tokens.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,gEAAgE;EAChE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;;EAEzB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,iCAAiC;EACjC,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;;EAEhC,qBAAqB;EACrB,wBAAwB;EACxB,gDAAgD;EAChD,+CAA+C;EAC/C,+CAA+C;EAC/C,2CAA2C;EAC3C,4CAA4C;EAC5C,sCAAsC;;EAEtC,YAAY;EACZ,0DAA0D;EAC1D,0DAA0D;EAC1D,0DAA0D;;EAE1D,SAAS;EACT,+CAA+C;EAC/C,iDAAiD;EACjD,4CAA4C;EAC5C,mDAAmD;;EAEnD,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,4CAA4C;;EAE5C,oBAAoB;EACpB,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;;EAE1B,WAAW;EACX,mCAAmC;EACnC,mCAAmC;;EAEnC,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".admin-layout .au-scope {\n  /* Space scale — 4px base, tighter than the dashboard side */\n  --admin-s0: 0;\n  --admin-s1: 2px;\n  --admin-s2: 4px;\n  --admin-s3: 8px;\n  --admin-s4: 12px;\n  --admin-s5: 16px;\n  --admin-s6: 20px;\n  --admin-s7: 28px;\n  --admin-s8: 40px;\n\n  /* Radii — sharp. 999px only on status dots, never on buttons. */\n  --admin-radius-sm: 3px;\n  --admin-radius-md: 5px;\n  --admin-radius-lg: 8px;\n  --admin-radius-dot: 999px;\n\n  /* Type scale */\n  --admin-text-micro: 10px;\n  --admin-text-xs: 11px;\n  --admin-text-sm: 12px;\n  --admin-text-base: 13px;\n  --admin-text-md: 14px;\n  --admin-text-lg: 18px;\n  --admin-font-weight-normal: 500;\n  --admin-font-weight-semibold: 600;\n  --admin-font-weight-bold: 700;\n  --admin-tracking-caps: 0.08em;\n  --admin-tracking-tight: -0.005em;\n\n  /* Surface layering */\n  --admin-bg-base: #0a0a0a;\n  --admin-bg-surface-1: rgba(255, 255, 255, 0.025);\n  --admin-bg-surface-2: rgba(255, 255, 255, 0.05);\n  --admin-bg-surface-3: rgba(255, 255, 255, 0.08);\n  --admin-bg-hover: rgba(255, 255, 255, 0.04);\n  --admin-bg-active: rgba(255, 255, 255, 0.07);\n  --admin-bg-sunken: rgba(0, 0, 0, 0.22);\n\n  /* Borders */\n  --admin-border-subtle: 1px solid rgba(255, 255, 255, 0.06);\n  --admin-border-default: 1px solid rgba(255, 255, 255, 0.1);\n  --admin-border-strong: 1px solid rgba(255, 255, 255, 0.18);\n\n  /* Text */\n  --admin-text-primary: rgba(255, 255, 255, 0.96);\n  --admin-text-secondary: rgba(255, 255, 255, 0.62);\n  --admin-text-muted: rgba(255, 255, 255, 0.4);\n  --admin-text-placeholder: rgba(255, 255, 255, 0.28);\n\n  /* Accent */\n  --admin-accent: #ef4444;\n  --admin-accent-ink: #ffffff;\n  --admin-accent-wash: rgba(239, 68, 68, 0.14);\n\n  /* Semantic status */\n  --admin-status-critical: #f87171;\n  --admin-status-signal: #fbbf24;\n  --admin-status-ambient: #9ca3af;\n  --admin-status-ok: #4ade80;\n\n  /* Motion */\n  --admin-transition-fast: 120ms ease;\n  --admin-transition-base: 180ms ease;\n\n  /* Shell metrics */\n  --admin-shell-pad-x: 24px;\n  --admin-shell-top: 48px;\n  --admin-shell-rail: 44px;\n  --admin-sidebar-w: 240px;\n}\n\n.admin-layout .sandbox-page {\n  --sbx-rail-offset: calc(48px + 44px);\n  --sbx-grid-gap: 12px;\n  --sbx-side-panel-w: clamp(320px, 28vw, 420px);\n}\n\n:root {\n  --admin-portal-z: 12000;\n}\n\n.admin-layout .au-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
